import { DataBean } from "../DataBean";

export class PayrollEntityProperties extends DataBean {

    public async getPayrollEntityPropertiesCatalogPorPropiedades(properties: any,maxRows: number ): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getPayrollEntityPropertiesCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

    public async getCreditPropertyDefinition(page:number,rows:number,group:string ): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getCreditPropertyDefinition_Number_Number_String", [page,rows,group]);
    }

    public async deletePayrollEntityProperties(idpayrollentityproperties: number): Promise<any> {
        return this.getCustomService("CreditCore", "boolean_deletePayrollEntityProperties_Number", [idpayrollentityproperties]);
    }

    public async updatePayrollEntityProperties(bean: any): Promise<any> {
        return this.getCustomService("CreditCore", "com.credit.bean.PayrollEntityProperties_updatePayrollEntityProperties_com.credit.bean.PayrollEntityProperties", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.credit.bean.PayrollEntityProperties"
            }
        ]);
    }

}
